import React, { useEffect } from "react";
import {
  Badge,
  Box,
  SkeletonCircle,
  SkeletonText,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPopularJobRolesListAsync,
  selectPopularJobRolesList,
} from "./PopularJobRolesListSlice";
import { Link, useParams } from "react-router-dom";
import { Footer } from "../../footer/footer";
import { EMPLOYER_COMPANY_LOGO_SAVE_URL } from "../../common/URLs";
import { BriefcaseIcon, BuildingOffice2Icon, CurrencyRupeeIcon } from "@heroicons/react/24/outline";

function PopularJobRolesList() {
  const dispatch = useDispatch();
  const job = useSelector(selectPopularJobRolesList);
  // const totalJobs = useSelector(selectPopularJobRolesTotal);

  const { uuid } = useParams();


  useEffect(() => {
    if (uuid) {
      dispatch(fetchPopularJobRolesListAsync({ uuid }));
    }
    window.scrollTo(0, 0);
  }, [dispatch, uuid]);


  return (
    <div>
      <div className="bg-gray-50 py-12 min-h-screen">
        <div className="sm:max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 flex flex-wrap justify-between items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">
                Job Posts By <span className="text-blue-600">Roles</span>
              </h2>
              <p className="mt-2 text-lg text-gray-600">
                Know your worth and find the job that qualifies your life
              </p>
            </div>
            <Link to="/jobs" className="mt-4 sm:mt-0">
              <button className="text-blue-600 text-lg font-semibold hover:text-blue-800 transition-colors">
                Browse all jobs →
              </button>
            </Link>
          </div>

          {/* Job Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {Array.isArray(job) && job.length > 0 ? (
              job.map((jobItem) => (
                <Link key={jobItem.uuid} to={`/jobs/${jobItem.uuid}`}>
                  <div className="bg-white rounded-lg shadow-md  transition-shadow duration-300 p-6">
                    <div className="flex items-start space-x-4">
                      {/* Company Logo */}
                      <div className="flex-shrink-0">
                        <img
                          className="h-16 w-16 rounded-full object-cover"
                          src={`${EMPLOYER_COMPANY_LOGO_SAVE_URL}${jobItem.company_logo}`}
                          alt={jobItem.company_name || "Company Logo"}
                        />
                      </div>

                      {/* Job Details */}
                      <div className="flex-grow space-y-1 ">
                        <div className="flex flex-wrap gap-1  w-full">
                          <div className="text-xl font-semibold text-gray-900 ">

                            {jobItem.job_title?.title || jobItem.job_name || "No Title"}
                          </div>
                          <div className="">
                            {jobItem.job_tag && (
                              <Badge colorScheme="blue" borderRadius="full" px={3} py={1}>
                                {jobItem.job_tag}
                              </Badge>
                            )}
                          </div>
                        </div>
                        <p className="text-sm text-blue-600  ">
                          <span className=" flex items-center gap-1 font-semibold"> <BriefcaseIcon className="w-4 h-4  text-zinc-500" /> {jobItem.job_name || "Job Name"}</span>
                          {/* {jobItem.department?.title && ` - ${jobItem.department.title}`} */}
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium flex items-center gap-1"><BuildingOffice2Icon className="w-4 h-4  text-zinc-500" />{jobItem.company_name || "Company Name"}</span>
                          {/* {jobItem.department?.title && ` - ${jobItem.department.title}`} */}
                        </p>
                        <p className="text-sm text-gray-600 ">
                          {/* <span className="font-semibold">{jobItem.company_name}</span> */}
                          <span className="font-medium flex items-center gap-1"> <BriefcaseIcon className="w-4 h-4  text-zinc-500" /> {jobItem.department?.title && ` ${jobItem.department.title}`}</span>
                        </p>
                        <p className="text-sm text-gray-600">
                          <span className="font-medium flex items-center gap-1">
                            <CurrencyRupeeIcon className="w-4 h-4  text-zinc-500" />

                            {jobItem.salary_min_amount} - {jobItem.salary_max_amount}, {jobItem.job_type}
                          </span>
                        </p>
                        {/* Job Tag */}

                      </div>

                      {/* Bookmark Icon */}
                      <div className="flex-shrink-0">
                        <label htmlFor={`bookmark-${jobItem.uuid}`} className="cursor-pointer">
                          <input type="checkbox" id={`bookmark-${jobItem.uuid}`} className="hidden" />
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="text-gray-400 hover:text-gray-600"
                          >
                            <path
                              d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </label>
                      </div>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <>
                <Box padding="6" boxShadow="lg" bg="white" borderradius="lg">
                  <SkeletonCircle size="16" />
                  <SkeletonText
                    mt="4"
                    noOfLines={4}
                    spacing="4"
                    skeletonHeight="2"
                  />
                </Box>
                <Box padding="6" boxShadow="lg" bg="white" borderradius="lg">
                  <SkeletonCircle size="16" />
                  <SkeletonText
                    mt="4"
                    noOfLines={4}
                    spacing="4"
                    skeletonHeight="2"
                  />
                </Box>
              </>
            )}
          </div>

          {/* Pagination Controls */}
          {/* <GridItem colSpan={2} display="flex" justifyContent="center">
            <div className="flex w-full justify-evenly items-center mt-4">
              <button
                className={`bg-gray-300 text-black px-4 py-2 rounded ${
                  currentPage === 1 ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={handlePrevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className={`bg-blue-500 text-white px-4 py-2 rounded ${
                  currentPage === totalPages
                    ? "opacity-50 cursor-not-allowed"
                    : ""
                }`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </GridItem> */}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PopularJobRolesList;